import useScript from '@hooks/useScript';
import React from 'react';

const Termly = ({ id }) => {
  useScript('https://app.termly.io/embed-policy.min.js', { 
    async: '',
  });

  return (
    <div
      // @ts-ignore
      name="termly-embed"
      data-id={id}
      data-type="iframe"
    >
    </div>
  );
};

export default Termly;
